import type React from 'react';

import { IconTick, IconMinus } from '@xing-com/icons';

import type { valueType } from '../../types';

export type ComparisonProps = {
  value: valueType;
};

export const Comparison: React.FC<ComparisonProps> = ({ value }) => {
  const { enabled, maxUsage } = value;
  if (enabled && maxUsage === -1) {
    return <IconTick />;
  } else if (!enabled) {
    return <IconMinus />;
  } else {
    return <span>{maxUsage}</span>;
  }
};
